/* Pertegaz footer — country/language side drawer. Delegated so open/close is robust. */
(function () {
  if (window.__pzFooterInit) return;
  window.__pzFooterInit = true;

  // move the drawer to <body> so position:fixed is viewport-relative (a transformed section
  // ancestor would otherwise trap it) and it can never sit under/behind the footer content
  function relocate() {
    var d = document.querySelector('[data-pz-locdrawer]');
    if (d && d.parentNode !== document.body) document.body.appendChild(d);
  }
  if (document.readyState !== 'loading') relocate();
  else document.addEventListener('DOMContentLoaded', relocate);

  function drawer() { return document.querySelector('[data-pz-locdrawer]'); }

  function open() {
    relocate(); // guarantee the drawer is a direct <body> child before showing it
    var d = drawer(); if (!d) return;
    d.hidden = false;
    requestAnimationFrame(function () { d.classList.add('is-open'); });
    // lock scroll the same way Dawn's cart/details drawers do — a class on <body> only.
    // (Setting overflow on <html> leaves iOS Safari permanently unscrollable after close.)
    document.body.classList.add('overflow-hidden');
  }
  function close() {
    var d = drawer(); if (!d) return;
    d.classList.remove('is-open');
    document.body.classList.remove('overflow-hidden');
    setTimeout(function () { d.hidden = true; }, 360);
  }

  // if the trigger sits inside the mobile hamburger menu, close that menu first so its
  // own scroll-lock (overflow-hidden-<breakpoint> on <body>) and overlay are cleared —
  // otherwise the page stays unscrollable after our drawer closes.
  function closeHostMenu(trigger) {
    if (!trigger.closest('.menu-drawer')) return;
    var hd = document.querySelector('header-drawer, menu-drawer');
    if (hd && typeof hd.closeMenuDrawer === 'function') {
      try { hd.closeMenuDrawer(new Event('pzloc')); } catch (err) {}
    }
    // belt-and-braces: drop any leftover breakpoint locks
    document.body.classList.remove('overflow-hidden-mobile', 'overflow-hidden-tablet', 'overflow-hidden-desktop');
  }

  // ---- open / close (delegated) ----
  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-pz-loc-open]');
    if (opener) { e.preventDefault(); closeHostMenu(opener); open(); return; }
    if (e.target.closest('[data-pz-loc-close]')) { e.preventDefault(); close(); return; }

    // dropdown pickers inside the drawer
    var trig = e.target.closest('[data-pz-loc-trigger]');
    if (trig) {
      var picker = trig.closest('[data-pz-loc-picker]');
      var panel = picker.querySelector('[data-pz-loc-panel]');
      var isOpen = picker.classList.toggle('is-open');
      if (panel) panel.hidden = !isOpen;
      trig.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      if (isOpen) {
        var s = picker.querySelector('[data-pz-loc-search]');
        if (s) { s.value = ''; s.dispatchEvent(new Event('input')); setTimeout(function () { s.focus(); }, 0); }
      }
      return;
    }

    // choosing an option
    var li = e.target.closest('[data-pz-loc-list] li');
    if (li) {
      var pk = li.closest('[data-pz-loc-picker]');
      var input = pk.querySelector('[data-pz-loc-input]');
      var current = pk.querySelector('[data-pz-loc-current]');
      var pan = pk.querySelector('[data-pz-loc-panel]');
      var tg = pk.querySelector('[data-pz-loc-trigger]');
      if (input) input.value = li.getAttribute('data-value');
      if (current) current.textContent = li.textContent.replace(/\s+/g, ' ').trim();
      pk.querySelectorAll('[data-pz-loc-list] li').forEach(function (o) { o.removeAttribute('aria-selected'); });
      li.setAttribute('aria-selected', 'true');
      pk.classList.remove('is-open');
      if (pan) pan.hidden = true;
      if (tg) tg.setAttribute('aria-expanded', 'false');
      return;
    }

    // click elsewhere → close any open picker (but keep the drawer open)
    if (e.target.closest('[data-pz-locdrawer]') && !e.target.closest('[data-pz-loc-picker]')) {
      document.querySelectorAll('[data-pz-loc-picker].is-open').forEach(function (p) {
        p.classList.remove('is-open');
        var pn = p.querySelector('[data-pz-loc-panel]'); if (pn) pn.hidden = true;
        var t = p.querySelector('[data-pz-loc-trigger]'); if (t) t.setAttribute('aria-expanded', 'false');
      });
    }
  });

  // country search filter (delegated)
  document.addEventListener('input', function (e) {
    var s = e.target.closest('[data-pz-loc-search]');
    if (!s) return;
    var pk = s.closest('[data-pz-loc-picker]');
    var q = s.value.trim().toLowerCase();
    pk.querySelectorAll('[data-pz-loc-list] li').forEach(function (li) {
      var name = li.getAttribute('data-name') || li.textContent.toLowerCase();
      li.classList.toggle('is-hidden', q !== '' && name.indexOf(q) === -1);
    });
  });

  document.addEventListener('keydown', function (e) {
    var d = drawer();
    if (e.key === 'Escape' && d && d.classList.contains('is-open')) close();
  });
})();
